import React from "react";

import { useNavigate } from "react-router-dom";

export default function Compheader({ img }) {
  // console.log(img);
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("nama");
    localStorage.removeItem("email");
    localStorage.removeItem("id");
    localStorage.removeItem("tamu");
    window.location.replace("/");
  };
  return (
    <div>
      <div
        className="card text-white"
        style={{
          borderRadius: "0px",
          backgroundImage:
            "url('https://p4.wallpaperbetter.com/wallpaper/398/874/541/champions-league-stadium-wallpaper-preview.jpg')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "containt",
          backgroundPosition: "center",
        }}
      >
        <div className="container my-5">
          <center>
            {img == "" || localStorage.getItem("tamu") != null ? (
              <img
                src="pemain.png"
                className="img-fluid mt-4"
                alt=""
                style={{
                  height: "150px",
                  borderRadius: "100%",
                  borderStyle: "solid",
                }}
              ></img>
            ) : (
              <img
                src={img}
                className="img-fluid mt-4"
                alt=""
                style={{
                  height: "150px",
                  width: "150px",
                  borderRadius: "100%",
                  borderStyle: "solid",
                }}
              ></img>
            )}
          </center>
          <h4 className="card-title fw-bold text-center mt-3">
            Hay, {localStorage.getItem("nama")}
          </h4>
          <p className="text-center">
            Apakah anda sudah melengkapi data profil<br></br>
            <button
              class="btn btn-sm text-white rounded-pill fw-bold bg-primary my-3 mx-4"
              onClick={logout}
              style={{ cursor: "pointer" }}
            >
              Logout <i className="fas fa-arrow-right-from-bracket"></i>
            </button>
          </p>
          <center></center>
        </div>
      </div>
    </div>
  );
}
